import { makeStyles, useTheme } from "@material-ui/core/styles";
import { props } from "bluebird";
import { CalendarLegendItem, CalendarLegendItemShape } from "./CalendarLegendItem";
import { CalendarLegendSection } from "./CalendarLegendSection";
import clsx from "clsx";
import { getStatusDefinition, getStatusDotColor } from "../../../constants/status";
import { resolveThemeMode } from "../../../utils/statusUtils";
import { CALENDAR_STATUS_OPTIONS } from "./calendarStatusConfig";

const useStyles = makeStyles(theme => ({
    root: {
        display: "inline-grid",
        gridTemplateColumns: "auto auto",
        columnGap: theme.spacing(3)
    },
    section: {
    },
    item: {
    }
}));

export interface CalendarLegendProps extends React.HTMLAttributes<HTMLDivElement> {

}

export function CalendarLegend(props: CalendarLegendProps) {
    const classes = useStyles();
    const theme = useTheme();
    const mode = resolveThemeMode(theme.palette.type);

    return (
        <div className={clsx(props.className, classes.root)}>
            <CalendarLegendSection title="Tests Legend" className={classes.section}>
                {/*
                  Colors here MUST come from getStatusDotColor - every status dot actually
                  rendered on the calendar tiles (Calendar.tsx's Channel A/B) already goes through
                  this same function, so a hardcoded theme.palette.* color here would silently
                  drift out of sync with what the tiles show (confirmed happened before this fix -
                  e.g. theme.palette.error.main vs the fail spec hex are both "red" but not the
                  same red). Labels stay as this legend's own existing descriptive text (e.g.
                  "Failed and Unresolved") rather than switching to getStatusDefinition's shorter
                  labels ("Fail") - only the color was ever wrong, not the wording.
                */}
                {/* No "Not Due" entry: the Calendar shows nothing for future dates (see Calendar.tsx). */}
                <CalendarLegendItem
                    className={classes.item}
                    label="Due"
                    color={getStatusDotColor("due", mode)}
                    shape="circle" />
                {CALENDAR_STATUS_OPTIONS.pastDueStatus === "overdue" && (
                    <CalendarLegendItem
                        className={classes.item}
                        label={getStatusDefinition("overdue").label}
                        color={getStatusDotColor("overdue", mode)}
                        shape="circle" />
                )}
                <CalendarLegendItem
                    className={classes.item}
                    label="Pass"
                    color={getStatusDotColor("pass", mode)}
                    shape="circle" />
                <CalendarLegendItem
                    className={classes.item}
                    label="Skipped"
                    color={getStatusDotColor("skipped", mode)}
                    shape="circle" />
                <CalendarLegendItem
                    className={classes.item}
                    label="Failed and Unresolved"
                    color={getStatusDotColor("fail", mode)}
                    shape="circle" />
                <CalendarLegendItem
                    className={classes.item}
                    label="Failed and Resolved"
                    color={getStatusDotColor("failed_resolved", mode)}
                    shape="circle" />
                <CalendarLegendItem
                    className={classes.item}
                    label={getStatusDefinition("missed").label}
                    color={getStatusDotColor("missed", mode)}
                    shape="circle" />
                <CalendarLegendItem
                    className={classes.item}
                    label={getStatusDefinition("incomplete").label}
                    color={getStatusDotColor("incomplete", mode)}
                    shape="circle" />
                <CalendarLegendItem
                    className={classes.item}
                    label={getStatusDefinition("pending").label}
                    color={getStatusDotColor("pending", mode)}
                    shape="circle" />
            </CalendarLegendSection>
            <CalendarLegendSection title="Scheduled Items Legend" className={classes.section}>
                <CalendarLegendItem
                    className={classes.item}
                    label="Due"
                    color={theme.palette.warning.light}
                    shape="square" />
                <CalendarLegendItem
                    className={classes.item}
                    label="Completed"
                    color={theme.palette.success.main}
                    shape="square" />
            </CalendarLegendSection>
        </div>
    )
}